import * as React from 'react';
import type { RestrictionEvent } from 'contracts/restricted-products/restricted-products';
import { RESTRICTION_EVENTS_NAME_MAP } from 'constants/restricted-products/restricted-products';
import { LockIcon, LockOpenIcon, RefreshCwIcon, ArrowLeftRightIcon } from 'lucide-react';
import { cn } from 'lib/utils';

type Props = React.ComponentProps<'div'> & {
  restrictionEvent: RestrictionEvent
}

export const EventAction = ({ restrictionEvent, className, ...props }: Props) => {
  const action = React.useMemo(() => {
    return restrictionEvent.action;
  }, [restrictionEvent.action]);

  const actionName = React.useMemo(() => {
    if (restrictionEvent?.resMovementType) {
      const { id, name } = restrictionEvent.resMovementType!;
      return [id, name].join(' - ');
    } else {
      return RESTRICTION_EVENTS_NAME_MAP[action];
    }
  }, [action, restrictionEvent?.resMovementType]);

  const Icon = React.useMemo(() => {
    switch (action) {
      case 'unblock':
        return LockOpenIcon;
      case 'updateQuantity':
        return RefreshCwIcon;
      case 'saleMovement':
        return ArrowLeftRightIcon;
      case 'block':
      default:
        return LockIcon;
    }
  }, [action]);
  
  return (
    <div className={cn('flex items-center gap-4', className, {
      'text-red-500': action === 'block',
      'text-green-500': action === 'unblock',
      'text-blue-500': action === 'updateQuantity',
      'text-purple-500': action === 'saleMovement',
    })}>
      <Icon className={cn('h-4 w-4')} />
      <span>{actionName}</span>
    </div>
  );
};